import store from "../store";
import { LOADING_HIDE, LOADING_SHOW } from "@/store/actions/loading";
const publicRoutes = ["/oauth"];
import { KeycloakUtils } from "@/config/keycloak";
import { AUTH_LOGOUT } from "../store/actions/auth";
import { CLEAR_STATE } from "../store/actions/menu";

const checkSSO = async next => {
  if (store.getters.isUsesSSO) {
    const valid = await KeycloakUtils.isTokenValid();
    if (!valid) {
      store.dispatch(AUTH_LOGOUT);
      store.dispatch(CLEAR_STATE);
      next("/login");
      return false;
    }
  }
  return true;
};

export const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated || store.getters.isUsesSSO) {
    next();
    return;
  }
  next("/");
};

export const ifAuthenticated = async (to, from, next) => {
  const ssoOk = await checkSSO(next);
  if (!ssoOk) return;

  if (store.getters.isAuthenticated) {
    next();
    return;
  }
  next("/login");
};

export const checkPermission = (to, from, next) => {
  if (
    publicRoutes.includes(to.fullPath) ||
    store.getters.getPermissoes.includes(to.fullPath)
  ) {
    return next();
  } else {
    const permissaoBasePublica = publicRoutes.find(permissao =>
      to.fullPath.startsWith(permissao)
    );
    const permissaoBase = store.getters.getPermissoes.find(permissao =>
      to.fullPath.startsWith(permissao)
    );
    const autoImplantacao = to.fullPath.startsWith(
      "/fornecedor/configuracao/auto-implantacao"
    );
    if (permissaoBasePublica || permissaoBase || autoImplantacao) {
      return next();
    }
    return next("/sem-permissao");
  }
};
export const ifUserHasAccess = async (to, from, next) => {
  const ssoOk = await checkSSO(next);
  if (!ssoOk) return;

  if (store.getters.isAuthenticated) {
    if (store.getters.permissoesLoaded) {
      return checkPermission(to, from, next);
    } else {
      store.dispatch(LOADING_SHOW);
      store.watch(
        () => store.getters.getPermissoes,
        () => {
          store.dispatch(LOADING_HIDE);
          return checkPermission(to, from, next);
        }
      );
    }
  } else {
    return next("/login");
  }
};
export const ifUserAdminHasAccess = async (to, from, next) => {
  const ssoOk = await checkSSO(next);
  if (!ssoOk) return;

  if (store.getters.isAuthenticated) {
    if (store.getters.isAdmin) {
      return next();
    } else {
      return next("/login");
    }
  } else {
    return next("/login");
  }
};
